import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "wrap" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "row tail" }
const _hoisted_6 = {
  key: 0,
  class: "info"
}
const _hoisted_7 = { class: "wrap" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "row bold" }
const _hoisted_10 = { class: "left" }
const _hoisted_11 = {
  key: 0,
  class: "right"
}
const _hoisted_12 = {
  key: 1,
  class: "right"
}
const _hoisted_13 = {
  key: 0,
  class: "row"
}
const _hoisted_14 = { class: "left" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "number" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "left" }
const _hoisted_19 = {
  key: 1,
  class: "empty"
}

import { reactive, ref, onMounted } from "vue"
import { orderQuery, orderExpress } from "@/utils/api"
import { toast } from "@/components/toast"

import ExpressDialog from '@/components/express.vue'
import Loading from '@/components/loading.vue'
import { getUrlParam } from "@/utils/util"
import FloatNav from '@/components/floatnav.vue'

interface QueryState {
    showExpress: boolean;
    loading: boolean;
    show: boolean;
    text: string;
    items: OrderItem[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'query',
  setup(__props) {

const form = reactive({
    id: '',
})

const state = reactive<QueryState>({
    showExpress: false,
    loading: false,
    show: false,
    text: '',
    items: []
})

const expressData = ref<OrderExpressRsp>()
const submit = async () => {
    if (!form.id) {
        toast('身份证号不能为空')
        return
    }
    state.loading = true
    const rsp = await orderQuery(form.id)
    state.loading = false
    if (rsp.result == 0) {
        state.text = '没有发现您的订单记录'
        state.items = rsp.data.items
        state.show = rsp.data.items.length == 0
    } else {
        state.text = rsp.message
        state.show = true
        toast(rsp.message)
    }
}

const clickItem = async (item: OrderItem) => {
    if (!item.success) {
        return
    }
    // state.loading = true
    // const rsp = await orderExpress(item.order_id)
    // state.loading = false
    // if (rsp.result == 0) {
    //     expressData.value = rsp.data
    //     state.showExpress = true
    // } else {
    //     toast(rsp.message)
    // }
}

const onResult = () => {
    state.showExpress = false
}


onMounted(() => {
    const id = getUrlParam('uid')
    form.id = id
    if (id) {
        submit()
    }
})



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "title" }, "请输入您的真实身份证信息进行查询", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "required" }, "*", -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label" }, "身份证号", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.id) = $event)),
              type: "text",
              class: "input",
              placeholder: "请输入你的身份证号"
            }, null, 512), [
              [_vModelText, form.id]
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: "btn",
          onClick: submit
        }, "查询订单信息")
      ])
    ]),
    (state.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "查询到的订单信息", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: index,
                onClick: ($event: any) => (clickItem(item))
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, "新购号码: " + _toDisplayString(item.number), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "space" }, null, -1)),
                  (item.success)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "运营商状态: " + _toDisplayString(item.vendor_status || '暂无'), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, "下单状态: " + _toDisplayString(item.rsp_msg), 1))
                ]),
                (item.express_no)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, "物流信息: " + _toDisplayString(item.express_name) + " " + _toDisplayString(item.express_no), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, "下单时间: " + _toDisplayString(item.create_at), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, "收件信息: " + _toDisplayString(item.name) + " " + _toDisplayString(item.mobile) + " " + _toDisplayString(item.street), 1)
                ])
              ], 8, _hoisted_8))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (state.show)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(state.text), 1))
      : _createCommentVNode("", true),
    _createVNode(FloatNav, { query: false }),
    (state.loading)
      ? (_openBlock(), _createBlock(Loading, { key: 2 }))
      : _createCommentVNode("", true),
    (state.showExpress && expressData.value)
      ? (_openBlock(), _createBlock(ExpressDialog, {
          key: 3,
          data: expressData.value,
          onResult: onResult
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}
}

})